export default __webpack_public_path__ + "static/media/pdfView.a3156f4f.svg";